<div class="breadcrumbGlobal">
    <a [routerLink]="['/mydashboard']">
        <mat-icon>home</mat-icon>
    </a>
    <mat-icon>chevron_right</mat-icon>
    <a [routerLink]="['/subscription-account']" translate>SUBSCRIPTIONS_ACCOUNTS.SUBSCRIPTIONS_ACCOUNTS_MANAGEMENT</a>
    <mat-icon>chevron_right</mat-icon>
    <span translate>SUBSCRIPTIONS_ACCOUNTS.ACCOUNTS_MANAGEMENT</span>
</div>

<tb-header specificTitle="SUBSCRIPTIONS_ACCOUNTS.ACCOUNTS_MANAGEMENT"></tb-header>

<div class="contentGlobal" style="margin-top: 0px">
    <div class="management" style="display: flex; flex-flow: row nowrap">

        <!-- ACCOUNT-TABLE -->
        <div style="flex: 1; background: white;">
            <ms-account-table [dataSourceUser]="dataSourceUser" [userFound]="userFound" [searchUser]="searchUser"
                [showFilterOptions]="showFilterOptions" (showTabsEvent)="showTabs($event)"
                (doSomethingEvent)="doSomething($event)" (showTabCreationAccountEvent)="showTabCreationAccount()"
                (applyFilter)="applyFilter($event)">
            </ms-account-table>
        </div>
        <!-- ACCOUNT-TABLE -->

        <div style="flex: 2; background: white">
            <div class="tab">
                <mat-tab-group *ngIf="showUserTab || showTabCA">
                    <mat-tab *ngIf="!showTabCA && !IsNotCreatedByYou">
                        <ng-template mat-tab-label>
                            <span translate>COMMONS.MAIN_DATA</span>
                        </ng-template>
                        <tb-edit-account [accountName]="selectedAccount" [imInAccountManegement]="true">
                        </tb-edit-account>
                    </mat-tab>
                    <mat-tab *ngIf="showTabCA">
                        <ng-template mat-tab-label>
                            <span translate>DIALOG.dialogTitle_3</span>
                        </ng-template>
                        <tb-account-create-account (saved)="onSaveAccount($event)"></tb-account-create-account>
                    </mat-tab>
                    <mat-tab *ngIf="!showTabCA || IsNotCreatedByYou">
                        <ng-template mat-tab-label>
                            <span translate>M_SUB_LIST</span>
                        </ng-template>
                        <mat-drawer-container autosize style="height: 550px">
                            <mat-drawer #drawer mode="side" position="end" style="width: 500px">
                                <tb-list-users-associated *ngIf="canShowDetail" [accountDetail]="accountDetail"
                                    [disableCheckbox]="disableCheckbox"
                                    [currentsubscriptionKey]="currentsubscriptionKey"
                                    [calledBySubsriptionManagement]="false" (close)="closeDrawer($event)"
                                    (rolesSaved)="setRoles($event)">
                                </tb-list-users-associated>
                            </mat-drawer>
                            <tb-subscription-list *ngIf="showSubscriptionsAssociated"
                                [selectedAccount]="selectedAccount" [isSaveEvent]="isSaveEvent"
                                (changeBackgroundSubscription)="changeBackgroundSubscription($event)"
                                (openDrawer)="openDrawer($event)" (initializeData)="initializeList($event)"
                                (setSaveEvent)="setSaveEvent()">
                            </tb-subscription-list>
                        </mat-drawer-container>
                    </mat-tab>
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <span translate>EDIT_SUBSCRIPTION.ROL</span>
                        </ng-template>
                        <mat-card>
                            <mat-card-content class="flex-column">
                                <div class="flex-column">
                                    <div class="subTitleTabContent" translate>ROLES_STRINGS.M_ACC_ROLES</div>
                                    <div class="flex-column flex-start">
                                        <mat-checkbox *ngFor="let Role of roleLevelAccount; index as i"
                                            [checked]="Role.Value" [id]="Role.RoleName"
                                            (change)="onValueChange($event, i)">
                                            <div class="flex-column">
                                                <span *ngIf="Role.RoleName === 'INTERNAL'"><b><span
                                                            translate>ROLES_STRINGS.INTERNAL</span></b> -
                                                    <span class="small"
                                                        translate>ROLES_STRINGS.M_DESC_INTERNAL</span></span>

                                                <span *ngIf="Role.RoleName === 'DEVELOPER'"><b><span
                                                            translate>ROLES_STRINGS.DEVELOPER</span></b> -
                                                    <span class="small"
                                                        translate>ROLES_STRINGS.M_DESC_DEVELOPER</span></span>

                                                <span *ngIf="Role.RoleName === 'DEVOPS'"><b><span
                                                            translate>ROLES_STRINGS.DEVOPS</span></b> -
                                                    <span class="small"
                                                        translate>ROLES_STRINGS.M_DESC_DEVOPS</span></span>

                                                <span *ngIf="Role.RoleName === 'SYS-ADMIN'"><b><span
                                                            translate>ROLES_STRINGS.SYS-ADMIN</span></b> -
                                                    <span class="small"
                                                        translate>ROLES_STRINGS.M_DESC_SYS-ADMIN</span></span>

                                                <span *ngIf="Role.RoleName === 'EXTERNAL-DVLP'"><b><span
                                                            translate>ROLES_STRINGS.EXTERNAL-DVLP</span></b> -
                                                    <span class="small"
                                                        translate>ROLES_STRINGS.M_DESC_EXTERNAL-DVLP</span></span>

                                                <span *ngIf="Role.RoleName === 'ESP-ADMIN'"><b><span
                                                            translate>ROLES_STRINGS.ESP-ADMIN</span></b> -
                                                    <span class="small"
                                                        translate>ROLES_STRINGS.M_DESC_ESP-ADMIN</span></span>

                                                <span *ngIf="Role.RoleName === 'CMS-ADMIN'"><b><span
                                                            translate>ROLES_STRINGS.CMS-ADMIN</span></b> -
                                                    <span class="small"
                                                        translate>ROLES_STRINGS.M_DESC_CMS-ADMIN</span></span>

                                                <span *ngIf="Role.RoleName === 'INDUSTRIES-EDITOR-ADMIN'"><b><span
                                                            translate>ROLES_STRINGS.INDUSTRIES-EDITOR-ADMIN</span></b> -
                                                    <span class="small"
                                                        translate>ROLES_STRINGS.M_DESC_INDUSTRIES-EDITOR-ADMIN</span></span>

                                                <span *ngIf="Role.RoleName === 'AMAZON-DSP'"><b><span
                                                            translate>ROLES_STRINGS.AMAZON-DSP</span></b> -
                                                    <span class="small"
                                                        translate>ROLES_STRINGS.M_DESC_AMAZON-DSP</span></span>
                                            </div>
                                        </mat-checkbox>
                                        <div class="flex-end">
                                            <button mat-flat-button class="left" color="primary"
                                                [disabled]="nothingHasChanged()" (click)="cancel()">
                                                <span translate>B_CANCEL</span>
                                            </button>
                                            <button mat-flat-button color="primary" [disabled]="nothingHasChanged()"
                                                (click)="onSaveChanges(roleLevelAccount)">
                                                <span translate>B_SAVE</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
</div>